module.exports = __webpack_public_path__ + "static/img/Daniel-Arzani.82278c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Daniel-Arzani.jpg
// module id = qeLu
// module chunks = 0